module.exports = __webpack_public_path__ + "static/media/Camera16.5125d7f6.jpg";